import React from 'react';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import ButtonClose from '../Form/ButtonClose';
import { useCartContext } from '../../Contexts/CartContext';
import HeaderLogo from './HeaderLogo';

interface HeaderMinimalProps {
    title?: string;
    subtitle?: string;
    onCancel?: CallableFunction;
    showCloseButton?: boolean;
    loading?: boolean;
}

const HeaderMinimal = ({title, subtitle, onCancel=() => {}, showCloseButton=true, loading} : HeaderMinimalProps) => {
    const { isMobile } = useLayoutContext();
    const { cartDisplay } = useCartContext();

    return (
        <header className="relative">
            {isMobile && showCloseButton && <div className='absolute -right-3 -top-3'><ButtonClose fixedOnTop onClick={() => onCancel()} /></div>}
            <div className="flex items-center justify-between gap-4 mr-8">
                
                {!isMobile && <HeaderLogo className="pointer-events-none max-h-8" classNameImage="w-full max-w-32 max-h-12" />}

                <div className='grid gap-1 w-full'>
                    <div className="text-xl font-extrabold text-shopfood-title leading-5">{title}</div>
                    {loading 
                        ? 
                            <div className="flex gap-1 w-full items-center">
                                <div className="bg-gray-100 w-14 h-5 rounded animate-pulse"></div>
                                {cartDisplay && <div className="bg-gray-100 w-18 h-5 rounded animate-pulse"></div>}
                            </div>

                        : subtitle && <div className="text-sm text-gray-500">{subtitle}</div>
                    }
                </div>
            </div>
        </header>
    )
}

export default HeaderMinimal;
